import React, { useEffect, useState } from "react";
import { useLang } from "../i18n";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Reveal } from "../components/motion";

const CATS = ["all", "physical", "ebook", "pamphlet", "program", "session", "membership"];

const Shop = () => {
  const { t, lang } = useLang();
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/shop/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  const cats = t("shop.categories");
  const filtered = filter === "all" ? products : products.filter((p) => p.category === filter);
  // Put the monthly Nordicvy Review first, then everything else in catalog order
  const shown = [...filtered].sort((a, b) => (a.lookup_key === "revue_unit" ? -1 : b.lookup_key === "revue_unit" ? 1 : 0));

  return (
    <div data-testid="shop-page" className="pt-36 pb-28 max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-primary/70 text-xs uppercase tracking-[0.25em] mb-6">{t("nav.shop")}</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tightest text-foreground mb-4">{t("shop.title")}</h1>
        <p className="text-foreground/65 font-light text-lg max-w-xl">{t("shop.sub")}</p>
      </Reveal>

      <div className="flex flex-wrap gap-2 mt-12 mb-12">
        {CATS.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c}`}
            onClick={() => setFilter(c)}
            className={`px-4 py-2 text-sm border transition-colors duration-200 ${
              filter === c ? "bg-primary text-primary-foreground border-primary" : "border-border text-foreground/70 hover:border-primary"
            }`}
          >
            {c === "all" ? (lang === "fr" ? "Tout" : "All") : cats[c]}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((p, i) => (
          <Reveal key={p.lookup_key} delay={(i % 3) * 0.06}>
            <ProductCard product={p} />
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Shop;
